import {
  Equipment_Read,
  getV1CompaniesIdEquipment,
  GetV1CompaniesIdEquipmentData,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { Equipment } from '~hooks/useEquipment/models';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Equipment_Read,
  Equipment,
  GetV1CompaniesIdEquipmentData
> & { companyId: string };

export default function AutocompleteCompanyEquipment<T extends FieldValues>({
  companyId,
  isDisabled,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteCompanyEquipment"
      fetchFn={{
        arguments: { path: { 'company-id': companyId } },
        request: getV1CompaniesIdEquipment,
      }}
      parseFn={(item: Equipment_Read) => {
        const parsed = Equipment.parse(item);

        return { _entity: parsed, label: parsed.name, value: parsed.id };
      }}
    />
  );
}
